<template>
  <div>
    <q-modal v-model="showLogin">
      <div class="layout-padding">

        <div class="modal-close">
          <q-btn color="primary" round dense icon="close" @click="showLogin = false;$router.push('/')"></q-btn>
        </div>

        <div class="q-py-lg">

          <template v-if="!user">
            <form @submit.prevent="login(slug)"
                  class="gutter-xs q-pa-xs"
                  @keydown="form.onKeydown($event)">

              <div class="text-center"><img :src="logo" width="200px"/></div>

              <!-- Msisdn -->
              <v-input path="msisdn"
                       v-model="form.msisdn"
                       :label="$t('Number')"
                       type="text"
                       color="highlight"
                       :form="form">
              </v-input>

              <!-- Submit Button -->
              <div class="row justify-center">
                <v-submit :label="$t('log in')"
                          :loadingLabel="$t('validating...')"
                          color="primary"
                          :form="form">
                </v-submit>
              </div>

            </form>

            <template slot="actions">
              <q-btn flat color="highlight" @click="$router.push({ name: 'password.request' })"
                     :label="$T('forgot your password?')"></q-btn>
            </template>
          </template>

          <div v-else class="q-pa-xl text-center">
            {{ $T('you are logged in!') }}
          </div>

        </div>
      </div>
    </q-modal>
  </div>

</template>

<script>
    import {mapGetters} from 'vuex'
    import axios from "axios"
    import Form from 'vform'
    import {QModal, QSpinnerPuff, QBtn, QCheckbox, QInput, Cookies} from 'quasar-framework'
    import VInput from "../../components/form/VInput";
    import CheckPolicy from "../policy";

    export default {
        name: 'VLogin',
        components: {
            VInput,
            QModal,
            QBtn,
            QSpinnerPuff,
            QCheckbox,
            QInput,
            CheckPolicy
        },

        data: () => ({
            form: new Form({
                msisdn: '',
                redirectTo: this.slug,
            }),
            logo: `${config.Url}${config.devAssetsFolder}/img/p4f.svg`
        }),

        computed: {
            ...mapGetters({
                user: 'auth/user',
                settings: 'local/settings'
            }),
            showLogin: {
                get() {
                    /*let cookie = Cookies.get('policy_subscribe_accepted')
                    if (!this.user && !cookie && this.settings('login')) {
                      //window.location.href = '/'
                      this.$router.push('/pages/policy?slug='+this.slug)
                      return false
                    }*/
                    return this.settings('login')
                },
                set(value) {
                    this.$store.dispatch('local/set', {key: 'login', value})
                }
            },
            slug: {
                get() {
                    return this.settings('redirect-route')
                },
                set(value) {
                    this.$store.dispatch('local/set', {key: 'redirect-route', value})
                }
            },
        },

        methods: {
            redirectToWapBilling() {
                axios.get(`${config.appUrl}/service-url`)
                    .then(({data}) => {
                        window.location.href = data;
                    })
            },
            async login(slug) {

                //var validNumber =  /\9715[046][0-9]{7}/;
                /*
                                if (this.form.msisdn.charAt(0) == "0")
                                    this.form.msisdn = this.form.msisdn.substring(1);

                                if(this.form.msisdn.length == 9)
                                  this.form.msisdn = "973"+this.form.msisdn;


                                /* if(!validNumber.test(this.form.msisdn))
                                 {
                                     this.$q.notify({
                                         color: 'negative',
                                         icon: 'error',
                                         message: "Invalid number",
                                         detail: "try again!",
                                         position: 'top',
                                     })
                                 } else {

                                     this.form.redirectTo = (slug != undefined) ? slug : "/";

                                     // Submit the form.
                                     if(!this.$route.query.hasOwnProperty('error_n'))
                                     {
                                         const {data} = await this.form.post(`${config.appUrl}/api/login`)
                                             window.location.href = data;

                                     }
                                 } */

                this.form.redirectTo = (slug != undefined) ? slug : "/";
                this.form.portal = Cookies.get('portal');

                // Submit the form.
                if(!this.$route.query.hasOwnProperty('error_n'))
                {
                    const {data} = await this.form.post(`${config.SkySMSUrl}/login`)
                    window.location.href = data;

                }

            }
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/auth/login.vue